'use strict';
import React, { useEffect, useCallback } from 'react';
import { Route, Switch, withRouter, useLocation, Redirect } from 'react-router-dom';
import './HomeContainer.scss';
import AccessManagementPage from '../admin/AccessManagementPage.jsx';
import PipelineTrackerPage from '../admin/PipelineTrackerPage.jsx';
import HgtContainer from '@/hgt';
import MyProjects from './myprojects/MyProjects.jsx';
import UserSettings from '../userSettings/UserSettings.jsx';
import Permissions from '../Permissions.jsx';
import LegalAgreements from '../legalAgreements/LegalAgreements.jsx';
import * as PermissionsTypes from '../../security/permissionTypes';
import RouteAuthorization from '../../security/RouteAuthorization.jsx';
import ProjectContainer from '../project/ProjectContainer';
import classNames from 'classnames';
import { ACCESS_MANAGEMENT, BUILD_A_STUDY, COE, HGT, LEGAL_AGREEMENTS, PIPELINE_TRACKER } from '../routes';
import StudyBuilderPage from './studyBuilder/StudyBuilderPage.jsx';
import { useProjectsQuery } from '@/redux/services/portal/projects.api.js';
import { useCurrentUserQuery } from '@/redux/services/portal/user.api.js';
import { usePendo } from '@/hooks/usePendo';

export const HomeContainer = (props) => {
	const { initialize } = usePendo();

	const { data: projects, isLoading: projectsIsLoading } = useProjectsQuery();
	const currentUser = useCurrentUserQuery();
	const { match, history } = props;
	const location = useLocation();

	const initializePendo = useCallback(() => {
		initialize();
	}, [initialize]);

	/** Render Router components, ignoring routes */
	const SettingsPage = /* istanbul ignore next */ (props) => <UserSettings {...props} />;
	const PermissionsPage = /* istanbul ignore next */ (props) => <Permissions {...props} />;
	const ProjectPage = /* istanbul ignore next */ useCallback((props) => <ProjectContainer projects={projects} currentUser={currentUser} {...props} />, []);
	const AccessManagementRoute = /* istanbul ignore next */ useCallback((props) => (
		<RouteAuthorization
			allowedPermissions={PermissionsTypes.CAN_VIEW_ADMIN}
			WrappedComponent={AccessManagementPage}
			{...props}
		/>
	), []);
	const HgtPage = /* istanbul ignore next */ useCallback((props) => (
		<RouteAuthorization
			allowedPermissions={PermissionsTypes.CAN_VIEW_ADMIN}
			WrappedComponent={HgtContainer}
			{...props}
		/>
	), []);
	const PipelineTrackerRoute = /* istanbul ingore next */ useCallback((props) => (
		<RouteAuthorization
			allowedPermissions={PermissionsTypes.CAN_VIEW_ADMIN}
			WrappedComponent={PipelineTrackerPage}
			{...props}
		/>
	), []);

	useEffect(() => {
		if (currentUser === undefined || currentUser === null){
			localStorage.clear();
		}
		if (currentUser.data) initializePendo();
	}, [currentUser.data]);

	return (
		<div className="HomeContainer app-content" data-testid="homeContainer">
			<div className={classNames("main", { wide: location?.pathname.indexOf(COE) >= 0, full: location?.pathname.indexOf(HGT) >= 0 })}>
				<Switch>
					<Route exact path={match.url}>
						<MyProjects history={history} />
					</Route>
					<Route
						exact
						path={`${match.url}/${ACCESS_MANAGEMENT}/status`}
						render={() => <Redirect to={`${match.url}/${PIPELINE_TRACKER}`} />}
					/>
					<Route path={`${match.url}/${BUILD_A_STUDY}`}>
						<StudyBuilderPage />
					</Route>
					<Route path={match.url + "/" + ACCESS_MANAGEMENT} match={match} render={AccessManagementRoute} />
					<Route path={match.url + "/" + PIPELINE_TRACKER} match={match} render={PipelineTrackerRoute} />
					<Route path={match.url + "/" + HGT} match={match} render={HgtPage} />
					<Route path={match.url + "/permissions"}>
						<PermissionsPage />
					</Route>
					<Route path={match.url + "/profilesettings"}>
						<SettingsPage />
					</Route>
					<Route path={match.url + "/" + LEGAL_AGREEMENTS}>
						<LegalAgreements />
					</Route>
					<Route path={match.url + "/project/:projectCode"} render={ProjectPage} />
				</Switch>
			</div>
		</div>
	);
};

export default withRouter(HomeContainer);
